import React from 'react'
import notFound from 'image/404_NotFound.jpg'

function NotFound() {
  return (
    <img
      style={{ width: '100%', position: 'absolute', zIndex: 1 }}
      src={notFound}
      alt="notFound"
    />
  )
}

export default NotFound
